import { useQuery } from '@tanstack/react-query';
import { api } from '@/modules/common/api/index.ts';
import { BalancesListV1SrBalancesGetParams, GetBalanceByDateResponse, RequestParams } from 'api';

export const CURRENT_CHART_BALANCE_QUERY_KEY = 'vestra/current-balance';

export const useChartBalanceQuery = (
  payload: BalancesListV1SrBalancesGetParams,
  register_id: number,
  params?: { disabled?: boolean; request?: RequestParams },
) => {
  return useQuery<GetBalanceByDateResponse>({
    queryKey: [
      CURRENT_CHART_BALANCE_QUERY_KEY,
      register_id,
      JSON.stringify(payload),
      JSON.stringify(params?.request || {}),
    ],
    staleTime: 1000 * 60 * 60 * 3, // 3 hours
    queryFn: async () => {
      const response = await api.v1.balancesListV1SrBalancesGet(payload, params?.request);

      return response.data;
    },
    retry: 2,
    enabled: !params?.disabled,
  });
};
